import { ChevronRight, ChevronDown } from 'lucide-react';
import { useState } from 'react';
import './MarginSection.css';

const MarginSection = () => {
  const [openAccordion, setOpenAccordion] = useState(null);

 const toggleAccordion = (item) => {
    setOpenAccordion(openAccordion === item ? null : item);
  };

  return (
    <section className="margin-section">
      <div className="margin-container">
        <div className="margin-header">
          <p className="margin-subtitle">500x Margin For Maximum Returns</p>
          <h2 className="margin-title">
            Make Big Moves with Lesser Capital as We Offer Upto 500x Margin.
          </h2>
        </div>

        <div className="margin-content">
          <div className="margin-illustration">
            <div className="illustration-card">
              <div className="chart-visual">
                <div className="chart-elements">
                  <div className="chart-circle"></div>
                  <div className="chart-bars">
                    <div className="bar" style={{ height: '60%' }}> </div>
                    <div className="bar" style={{ height: '80%' }}></div>
                    <div className="bar" style={{ height: '40%' }}></div>
                    <div className="bar" style={{ height: '90%' }}></div>
                    <div className="bar" style={{ height: '70%' }}></div>
                    <div className="bar" style={{ height: '100%' }}></div>
                  </div>
                  <div className="chart-line"></div>
                  <div className="chart-percent">%</div>
                  <div className="coin-stack">
                    <div className="coin"></div>
                    <div className="coin"></div>
                    <div className="coin"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="secure-investment">
            {/* <div className="secure-header">
              <h3 className="secure-title">Secure Investment</h3>
              <ChevronDown size={24} className="secure-icon-toggle" />
            </div>
            <p className="secure-description">
             
            </p> */}

            <div className="accordion">
              <div className="accordion-item">
                <div className="accordion-header"  onClick={() => toggleAccordion("Secure Investment")}>
                  <span>Secure Investment</span>
                  {openAccordion === "zero" ? (
                    <ChevronDown size={20} className="accordion-icon" />
                  ) : (
                    <ChevronRight size={20} className="accordion-icon" />
                  )}
                </div>
                {openAccordion === "Secure Investment" && (
                  <div className="accordion-content">
                    <p> At tredixo.store, we safeguard your interests and ensure your
              investment journey is as secure as it is prosperous.</p>
                  </div>
                )}
              </div>
              <div className="accordion-item">
                <div className="accordion-header"  onClick={() => toggleAccordion("zero")}>
                  <span>low  Brokerage</span>
                  {openAccordion === "zero" ? (
                    <ChevronDown size={20} className="accordion-icon" />
                  ) : (
                    <ChevronRight size={20} className="accordion-icon" />
                  )}
                </div>
                {openAccordion === "zero" && (
                  <div className="accordion-content">
                    <p>Say goodbye to brokerage blues! tredixo.store brings you a trading revolution with low Brokerage – because we believe in maximising your gains, not cutting into them.</p>
                  </div>
                )}
              </div>

              <div className="accordion-item">
                <div className="accordion-header" onClick={() => toggleAccordion("margin")}>
                  <span>500x Margin Facilities</span>
                  {openAccordion === "margin" ? (
                    <ChevronDown size={20} className="accordion-icon" />
                  ) : (
                    <ChevronRight size={20} className="accordion-icon" />
                  )}
                </div>
                {openAccordion === "margin" && (
                  <div className="accordion-content">
                    <p>At tredixo.store, we've got your back, ready to fuel your financial ambitions. Let's turn your ideas into profits with huge margins!</p>
                  </div>
                )}
              </div>

              <div className="accordion-item">
                <div className="accordion-header" onClick={() => toggleAccordion("deposit")}>
                  <span>24x7 Deposit & Withdrawal</span>
                  {openAccordion === "deposit" ? (
                    <ChevronDown size={20} className="accordion-icon" />
                  ) : (
                    <ChevronRight size={20} className="accordion-icon" />
                  )}
                </div>
                {openAccordion === "deposit" && (
                  <div className="accordion-content">
                    <p>Our platform allows you to deposit & withdrawal around the clock, ensuring your financial freedom</p>
                  </div>
                )}
              </div>

              <div className="accordion-item">
                <div className="accordion-header" onClick={() => toggleAccordion("support")}>
                  <span>Round-The-Clock Customer Support</span>
                  {openAccordion === "support" ? (
                    <ChevronDown size={20} className="accordion-icon" />
                  ) : (
                    <ChevronRight size={20} className="accordion-icon" />
                  )}
                </div>
                {openAccordion === "support" && (
                  <div className="accordion-content">
                    <p>Experience trading confidence with a dedicated team always by your side.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarginSection;
